// The banner and sidebar already say what a chat first works on; the marker is for when it switches.
export function withoutOpeningFocus<
  T extends { userAction?: { actionType: string } | null },
>(entries: readonly T[]): readonly T[] {
  const opening = entries.find(
    (entry) => entry.userAction?.actionType === "focusWorkflow"
  );
  return opening ? entries.filter((entry) => entry !== opening) : entries;
}
